<template>
  <div class="form_privato">
    <b-container  class="border rounded pt-4 px-4 my-5 bg-white">
      <b-form>
        <b-container class="px-0">
          <b-row>
            <b-col md="6" class="text-left mb-3">
              <label for="cliente">Sei già cliente?<span class="text-danger">*</span></label>
              <b-form-select
                id="cliente"
                ref="cliente"
                v-model="form.cliente"
                :options="opt_cliente"
                :state="this.stato.cliente"
                aria-describedby="invalid_cliente"
                >
                <template v-slot:first>
                  <b-form-select-option :value="null" >Scegli...</b-form-select-option>
                </template>
                </b-form-select>
              <b-form-invalid-feedback id="invalid_cliente">campo abbbligatorio</b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" class="text-left mb-3">
            <label for="cognome_nome">Come ti chiami / Nome della tua azienda?<span class="text-danger">*</span></label>
            <b-form-input 
                id="cognome_nome"
                ref="cognome_nome"
                v-model="form.cognome_nome"
                autocomplete="off"
                maxlength="150"
                :state="this.stato.cognome_nome"
                aria-describedby="invalid_cognome_nome"
                required
                ></b-form-input>
            <b-form-invalid-feedback id="invalid_cognome_nome">campo obbligatorio</b-form-invalid-feedback>
            </b-col>
            <b-col md="6" class="text-left mb-3">
              <label for="contatto">Come sei stato contattato?<span class="text-danger">*</span></label>
              <b-form-select
                id="contatto"
                ref="contatto"
                v-model="form.contatto"
                :options="opt_cont"
                :state="this.stato.contatto"
                aria-describedby="invalid_contatto"
                >
                <template v-slot:first>
                  <b-form-select-option :value="null" >Scegli...</b-form-select-option>
                </template>
                </b-form-select>
              <b-form-invalid-feedback id="invalid_contatto">campo abbbligatorio</b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" class="text-left mb-3">
              <label for="presentazione">Come si sono presentati?<span class="text-danger">*</span></label>
              <b-form-select
                id="presentazione"
                ref="presentazione"
                v-model="form.presentazione"
                :options="opt_pres"
                :state="this.stato.presentazione"
                aria-describedby="invalid_presentazione"
                >
                <template v-slot:first>
                  <b-form-select-option :value="null" >Scegli...</b-form-select-option>
                </template>
                </b-form-select>
              <b-form-invalid-feedback id="invalid_presentazione">campo abbbligatorio</b-form-invalid-feedback>
            </b-col>
            <b-col md="6" class="text-left mb-3">
              <label for="convincimento">Cosa hanno detto per convincerti?<span class="text-danger">*</span></label>
              <b-form-select
                id="convincimento"
                ref="convincimento"
                v-model="form.convincimento"
                :options="opt_conv"
                :state="this.stato.convincimento"
                aria-describedby="invalid_convincimento"
                >
                <template v-slot:first>
                  <b-form-select-option :value="null" >Scegli...</b-form-select-option>
                </template>
                </b-form-select>
              <b-form-invalid-feedback id="invalid_convincimento">campo abbbligatorio</b-form-invalid-feedback>
            </b-col>
            <!-- <b-col cols="12">
              <b-form-group
              id="presentazione"
              class="text-left"
              label-for="presentazione"
              :state="this.stato.presentazione"
              invalid-feedback="è necessario inserire una descrizione"
              >
              <template slot="label">Come si sono presentati?<span class='text-danger'>*</span></template>
                <b-form-textarea
                    id="presentazione"
                    ref="presentazione"
                    maxlength="1000"
                    v-model="form.presentazione"
                    placeholder=""
                    size="sm"
                    rows="4"
                    :class="this.stato.presentazione == false ? 'border border-danger' : ''"
                    no-resize
                ></b-form-textarea>
              </b-form-group>
            </b-col> -->
          </b-row>
          <!-- <b-row>
            <b-col cols="12">
              <b-form-group 
                id="convincimento"
                class="text-left"
                label-for="convincimento"
                :state="this.stato.convincimento"
                invalid-feedback="è necessario inserire una descrizione"
                >
                <template slot="label">Cosa hanno detto per cercare di convincerti?<span class='text-danger'>*</span></template>
                <b-form-textarea
                    id="convincimento"
                    ref="convincimento"
                    maxlength="1000"
                    v-model="form.convincimento"
                    placeholder=""
                    size="sm"
                    rows="4"
                    :class="this.stato.convincimento == false ? 'border border-danger' : ''"
                    no-resize
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row class="p-2 mb-3">
              <b-col cols="12" class="mb-2">
                Contatto<span class="text-danger">*</span>
              </b-col>
              <b-col md="6" class="text-left mb-3">
              <label for="telefono">Il tuo recapito telefonico</label>
              <b-form-input
                  id="telefono"
                  ref="telefono"
                  v-model="form.telefono"
                  @keypress="onlyNumber"
                  autocomplete="off"
                  maxlength="50"
                  :state="this.stato.telefono"
                  aria-describedby="invalid_telefono"
                  required
              ></b-form-input>
              <b-form-invalid-feedback id="invalid_telefono">è necessario inserire almeno un recapito. telefono oppure email</b-form-invalid-feedback>
              </b-col>
              <b-col md="6" class="text-left mb-3">
              <label for="email">La tua email</label>
              <b-form-input
                  id="email"
                  ref="email"
                  v-model="form.email"
                  autocomplete="off"
                  maxlength="150"
                  :formatter="formatterInputLowercase"
                  :state="this.stato.email"
                  aria-describedby="invalid_email"
                  required
              ></b-form-input>
              <b-form-invalid-feedback id="invalid_email">{{invalid_email}}</b-form-invalid-feedback>
              </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="12">
              <b-form-group 
                id="note"
                class="text-left"
                label-for="note"
                >
                <template slot="label">Note</template>
                <b-form-textarea
                    id="note"
                    ref="note"
                    maxlength="1000"
                    v-model="form.note"
                    placeholder=""
                    size="sm"
                    rows="4"
                    no-resize
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <AreaPrivacy/>
          <b-row class="py-3 px-4">
            <p class="text-justify text-bold-slim text-blue"><u>{{ text_auto0 }}</u></p>
            <!-- <p class="text-justify">{{ text_auto1 }}</p>
            <b-form-group id="input-group-4">
              <b-form-checkbox-group v-model="form.autorizzo" id="checkboxes-4" class="text-left ml-3">
                <b-form-checkbox value="si" class="mr-0" :disabled="!div_proc_vis">autorizzo il Titolare al trattamento dei miei dati personali per le finalità di cui al paragrafo <b>3</b>.</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
            <b-form-group id="input-group-5">
              <b-form-checkbox-group v-model="form.non_autorizzo" id="checkboxes-5" class="text-left ml-3">
                <b-form-checkbox value="no" class="mr-0" :disabled="!div_proc_vis">non autorizzo il Titolare al trattamento dei miei dati personali per le finalità di cui al paragrafo <b>3</b>.</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
            <p class="text-justify"><span v-html="this.text_auto2"></span></p> -->
          </b-row>
          <hr class="mb-3">
          <b-row v-if="!this.finito" align-v="center">
            <b-col sm="9" class="pb-3 pb-sm-0">
              <b-row>
                <b-col class="text-left">
                  <p style="font-size:0.8rem" class="text-bold-slim mb-0">Tutti i campi segnati con un asterisco (<span class="text-danger">*</span>) sono obbligatori.</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-button type="button" class="mr-5 mr-md-0 mb-3 float-right" :disabled="!salva_vis || btn_salva_disabled" @click="SubmitForm">Invia</b-button>
            </b-col>
          </b-row>
          <b-row v-if="this.finito" :class="this.esito_positivo ? 'box-success' : 'box-failure'" class="p-3 mx-2 my-3 rounded" >
            <b-col class="px-0">
              <p class="text-justify mb-0"><span v-html="this.testo_end"></span></p>
            </b-col>
          </b-row>
          <!-- <div>{{ form.autorizzo }}</div> -->
        </b-container>
      </b-form>
    </b-container>
  </div>
</template>

<script>
import AreaPrivacy from '@/components/AreaPrivacy'
import axios from 'axios'
export default {
  name: 'Form',
  components: {
    AreaPrivacy
  },
  data: function() {
      return {
        c_form: true,
        form: {
          cliente: null,
          cognome_nome: '',
          telefono: '',
          email: '',
          contatto: null,
          presentazione: null,
          convincimento: null,
          note: '',
          autorizzo: [],
          non_autorizzo: [],
        },
        stato: {
          cliente: null,
          cognome_nome: null,
          telefono: null,
          email: null,
          contatto: null,
          presentazione: null,
          convincimento: null,
        },
        token:'',
        invalid_email: '',
        text_auto0:`Per poter proseguire è necessario visualizzare l'intera sezione Privacy`,
        text_auto1:`Io sottoscritto/a, avendo preso visione dell’Informativa riportata nella presente sezione Privacy:`,
        text_auto2:`Il consenso è facoltativo: posso in ogni momento revocare la mia dichiarazione di consenso a CVA Energie S.r.l. a s.u., 
        inviando una mail all’indirizzo: <a href="mailto:privacy@cvaenergie.it">privacy@cvaenergie.it</a>`,
        testo_success: `
        Grazie!<br>
        Ti informiamo di avere ricevuto correttamente i Tuoi dati.<br>
        A breve riceverai un'email di conferma. Se non ricevi una risposta, per favore controlla la tua cartella "spam". 
        `,
        finito: false,
        esito_positivo: false,
        testo_end: '',
        btn_salva_disabled: false,
        erroClassCheckbox: ['border', 'border-danger', 'rounded', 'm-3', 'pt-3'],
        submit: false,
        opt_cliente: [{'text':'Si', 'value': 'Y'},{'text':'No', 'value': 'N'}],
        opt_cont: [],
        opt_pres: [],
        opt_conv: []
      }
  },
  mounted() {
    this.optSelect()
  },
  watch:{
      div_proc_vis: function (val) {
        if(val == false) {
        this.form.autorizzo = []
        this.form.non_autorizzo = []
        } else if (val == true) {
          this.form.autorizzo = [ "si" ]
        }
      },
        auto: function (val) {
        if(val == 'si')
        this.form.non_autorizzo = []
      },
        non_auto: function (val) {
        if(val == 'no')
        this.form.autorizzo = []
      }
  },
  computed:{
    div_proc_vis: function(){
      return this.$store.state.div_proc_vis;
    },
    salva_vis: function(){
      if (this.form.autorizzo == 'si'){
        return true
      } else {
        return false
      }
    },
    auto: function(){
      return this.form.autorizzo;
    },
    non_auto: function(){
      return this.form.non_autorizzo;
    },
  },
  methods: {
    optSelect() {
      axios.get('opt_select')
      .then((res) => {
          this.opt_cont = res.data.opt_cont
          this.opt_pres = res.data.opt_pres
          this.opt_conv = res.data.opt_conv
      })
      .catch((error) => {
        console.error(error);
      });
    },
    onlyNumber ($event) {
      // console.log($event.keyCode); //keyCodes value
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      /*if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { */// 46 is dot
      if ((keyCode < 48 || keyCode > 57)) {
          $event.preventDefault();
      }
    },
    checkForm: function () {
      if (this.form.cliente == null) {
        this.stato.cliente = false
        this.$refs.cliente.focus()
        return false
      } else {
      this.stato.cliente = null
      }
      if (this.form.cognome_nome == '') {
          this.stato.cognome_nome = false
          this.$refs.cognome_nome.focus()
          return false
      } else {
        this.stato.cognome_nome = null
      }
      if (this.form.contatto == null) {
        this.stato.contatto = false
        this.$refs.contatto.focus()
        return false
      } else {
      this.stato.contatto = null
      }
      if (this.form.presentazione == null) {
          this.stato.presentazione = false
          this.$refs.presentazione.focus()
          return false
      } else {
        this.stato.presentazione = null
      }
      if (this.form.convincimento == null) {
          this.stato.convincimento = false
          this.$refs.convincimento.focus()
          return false
      } else {
        this.stato.convincimento = null
      }
      if (this.form.telefono == '' && this.form.email == '') {
          this.stato.telefono = false
          this.$refs.telefono.focus()
          return false
      } else {
        this.stato.telefono = null
      }
      if (this.form.email == '' && this.form.telefono == '') {
          this.stato.email = false
          this.invalid_email = 'è necessario inserire almeno un recapito. telefono oppure email'
          this.$refs.email.focus()
          return false
      } else if (!this.validEmail(this.form.email)) {
          this.stato.email = false
          this.invalid_email = 'formato email non valido'
          this.$refs.email.focus()
          return false
      } else {
        this.stato.email = null
      }
      return true
    },
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()
      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('login')
      return token
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validCF: function (cf) {
      var re = /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/;
      return re.test(cf);
    },
    SubmitForm() {
      this.overlayActive(true)
      this.btn_salva_disabled = true
      if(this.checkForm()) {
        this.recaptcha().then((res) => {
          // console.log(JSON.stringify(this.form))
          // delete this.form.autorizzo
          // delete this.form.non_autorizzo
          this.form['autorizzo_privacy'] = "si"
          this.form['g-recaptcha-response'] = res
          // console.log(JSON.stringify(this.form))
          const formData = new FormData();
          formData.append('form_data', JSON.stringify(this.form));
          const path = 'submit_form';
          axios.post(path,formData)
            .then((res) => {
              // console.log(res)
              let esito = res.data.inserito
              if (esito == "si") {
                this.submit = true
                this.finito = true
                this.esito_positivo = true
                this.testo_end = this.testo_success
              } else if (esito == "no") {
                this.finito = true
                this.esito_positivo = false
                this.testo_end = `Iscrizione già effettuata per il codice fiscale: ${this.form.cf}.`
              } else {
                this.finito = true
                this.esito_positivo = false
                this.testo_end = "Registrazione non andata a buon fine. Si prega di riprovare."
              }
              this.overlayActive(false)
              })
            .catch((error) => {
              error
              // console.error(error);
              this.overlayActive(false)
              this.finito = true
              this.testo_end = "Si è verificato un problema"
            });
          })
      .catch((error) => {
        error
        // console.error(error);
        this.overlayActive(false)
      });
      } else {
        this.btn_salva_disabled = false
        this.overlayActive(false)
      }
    },
    formatterInputLowercase(value) {
      return value.toLowerCase()
    },
    formatterInputUppercase(value) {
      return value.toUpperCase()
    },
    fileCaricato(f) {
      this.form.cv = f
    },
    overlayActive(value) {
      this.$store.state.overlayActive = value
    }
  }
}
</script>

<style lang="scss">
.btn {
  border: 0 !important;
  color: #343535 !important;
  font-weight: 600 !important;
  background-color: #00bbe2 !important;
  border-radius: 50px !important;
  //min-width: 200px;
  //font-size: 1.5rem !important;
  // padding: 6px 20px 6px 20px !important;
}
.form-control.on_focus_element {
  box-shadow: none !important ;
  height:0px !important;
  padding:0 !important;
  border:0 !important;
}

.form-control:hover.on_focus_element {
  box-shadow: none !important ;
}


</style>

